<template>
  <div class="m5">
    <ul class="nav pb-4">
      <li>
        <a href="/">Home ></a>
      </li>
      <li>
        <a href="/admin/stakeholder">Stakeholder Inventory ></a>
      </li>
      <li>
        <a href="/admin/research" class="active">Research and Knowledge</a>
      </li>
    </ul>
    <h3 style="color: #30ab4c">RESEARCH AND KNOWLEDGE DIVISION</h3>
    <div class="align-items-center justify-content-between d-flex">
      <router-link to="/admin/add-new-stakeholder"
        ><span
          class="add-user d-flex align-items-center justify-content-center my-4"
          style="
            width: 264px;
            height: 62px;
            background: #30ab4c 0% 0% no-repeat padding-box;
            border-radius: 3px;
            color: #ffffff;
            cursor: pointer;
          "
        >
          + ADD NEW STAKEHOLDER
        </span></router-link
      >
      <form>
        <div class="input-group input-wrap">
          <span class="input-group-append">
            <button class="btn border-o ms-n5" type="button">
              <i class="fa fa-search"></i>
            </button>
          </span>
          <input class="input" type="search" value="search" id="example-search-input" />
        </div>
      </form>
    </div>
    <!--table-->
    <div class="">
      <h5 style="color: #707070; padding: 15px; background: #30ab4c1a 0% 0% no-repeat padding-box">
        NAME OF STAKEHOLDERS
      </h5>
      <stakholderRows :infos="infos" />
    </div>
    <!--pagination-->
    <div class="overflow-auto d-flex m-5">
      <b-pagination></b-pagination>
      <!-- <p class="mt-3">Current Page: {{ currentPage }}</p> -->
    </div>
    <!--pagination-end-->
  </div>
</template>

<script>
import stakholderRows from '../../components/stakholderRows.vue';

export default {
  name: 'StakeholderResearch',
  components: {
    stakholderRows,
  },
  data() {
    return {
      infos: [
        {
          id: 1,
          title: 'Federal Ministry of Health Administrator',
        },
        {
          id: 2,
          title: 'National Centre for Disease Control Administrator',
        },
        {
          id: 3,
          title: 'Lorem Ipsum dolor et al cognif Administrator',
        },
        {
          id: 4,
          title: 'Lorem Ipsum dolor et al cognif Administrator',
        },
        {
          id: 5,
          title: 'Lorem Ipsum dolor et al cognif Administrator',
        },
        {
          id: 6,
          title: 'Lorem Ipsum dolor et al cognif Administrator',
        },
        {
          id: 7,
          title: 'Lorem Ipsum dolor et al cognif Administrator',
        },
      ],
    };
  },
};
</script>

<style scoped>
.input-wrap {
  width: 343px;
  height: 48px;
  background: #30ab4cb5 0% 0% no-repeat padding-box;
  opacity: 0.31;
}
.input {
  background: transparent;
  border: none;
  width: 85%;
}
.pagination {
  margin: auto;
}
</style>
